"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _solarReact = require("@solar/solar-react");

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Blocked = function Blocked(_ref) {
  var title = _ref.title,
      message = _ref.message,
      Icon = _ref.Icon,
      logoutLabel = _ref.logoutLabel,
      onLogout = _ref.onLogout;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: Icon,
    label: message
  }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    color: 'primary',
    onClick: function onClick() {
      return onLogout();
    }
  }, logoutLabel));
};

Blocked.propTypes = {
  Icon: _propTypes["default"].node,
  logoutLabel: _propTypes["default"].string,
  message: _propTypes["default"].string,
  onLogout: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string
};
Blocked.defaultProps = {
  Icon: _Block["default"],
  logoutLabel: 'Afmelden',
  message: 'Toegang geblokkeerd',
  title: 'Blocked'
};
var _default = Blocked;
exports["default"] = _default;